import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import ProcessMain from '../../containers/ProcessStatus';
import i18n from '../../resources/i18n';
/**
 * 進捗状況表示画面
 * @param props
 */
const ProcessStatus: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('ProcessStatus_0016')} />
			<ProcessMain adminView={false} {...props} />
		</>
	);
};

export default ProcessStatus;



// WEBPACK FOOTER //
// ./src/pages/personal/ProcessStatus.tsx